import React from 'react'
import Skeleton from 'react-loading-skeleton'

import styles from './styles.module.css'

const CartCardSkeleton = () => {
  return (
    <div className={styles.container}>
      <Skeleton width={86} height={86} />
      <div className={styles.content}>
        <Skeleton className={styles.title} />
        <div className="d-flex justify-content-between">
          <div className="h-100 d-flex flex-column justify-content-end align-items-center">
            <div className="d-flex align-items-center"></div>
            <Skeleton width={62} height={17} />
          </div>
          <div className="d-flex flex-column align-items-end">
            <Skeleton width={19} height={14} />
            <Skeleton width={89} height={31} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CartCardSkeleton
